var headerStyle = {
	fontFamily: "Ubuntu-Regular",
	fontSize: 28,
	fill: "0xF0F8FF",
};

var textStyle2 = {
	fontFamily: "Ubuntu-Regular",
	align: "left",
	fontSize: 20,
	fill: "0xFFD700",
	letterSpacing: 0,
	wordWrap: true,
	wordWrapWidth: 1040,
};

var textStyle = {
	fontFamily: "Ubuntu-Regular",
	align: "left",
	fontSize: 20,
	fill: "0xFFD700",
	letterSpacing: 0,
	wordWrap: true,
	wordWrapWidth: 850,
};

var textShort = {
	fontFamily: "Ubuntu-Regular",
	align: "left",
	fontSize: 20,
	fill: "0xFFD700",
	letterSpacing: 0,
	wordWrap: true,
	wordWrapWidth: 890,
};

const freeSpinStyle = new PIXI.TextStyle({
	dropShadow: true,
	dropShadowBlur: 3,
	dropShadowDistance: 2,
	fill: ["#fff6b7", "#ffbc0c"],
	fontFamily: "Arial Black",
	fontSize: 40,
	letterSpacing: -2,
});

export const infotexts = {
	cs: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "ZÁKLADNÍ ÚDAJE:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Pětiválcová hra se 4 sloty a hrou na 40 výherních liniích. " +
					"Výhry jsou platné zleva doprava. " +
					"Je možné během jedné hry získat výhru na více výherních liniích, to znamená, že výhry jsou sčítány.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SYMBOL JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Nahrazuje jakýkoliv symbol. ",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text: "Vždy, když hráči dopadne válec plný jednoho ze symbolů, změní se v příští otočce se stejnou sázkou celý tento válec na symbol Joker(Wild).",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "BONUSOVÁ HRA FREE SPINS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"3 symboly Hvězda(SCATTER) spouští bonusovou hru FREE SPINS. " +
					"Hráč obdrží 5 FREE SPINS se symbolem SCATTER na celých válcích 1,3 a 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	sk: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "Základné údaje:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Päťvalcová hra so štyrmi symbolmi na valci a hrou na 40 výherných líniách. " +
					"Výhry sú platné zľava doprava okrem symbolu HVIEZDA (SCATTER), ktorý platí kdekoľvek na valci. " +
					"Behom jednej hry je možné získať výhru na viacerých výherných líniách, to znamená, že výhry sú sčítané. " +
					"Platí iba najvyššia výhra na výhernej línii. " +
					"RTP=95,00%",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 180,
				text: "SYMBOL JOKER (Žolík):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 215,
				text: "Wild nahrádza akýkoľvek symbol okrem symbolu HVIEZDA (SCATTER).",
				styles: textShort,
			},
			wild: {
				x: 120,
				y: 340,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 375,
				text:
					"Symbol JOKER (Žolík) nahrádza akýkoľvek symbol okrem symbolu HVIEZDA (SCATTER). " +
					"Vždy, keď hráč získa valec plný jedného zo symbolov (bez symbolu JOKER (Žolík)), " +
					"zmení sa v nasledujúcej otočke s rovnakou stávkou celý tento valec na valec s roztiahnutým symbolom JOKER (Žolík). " +
					"Ak hráč získa 5 valcov iba s rovnakým symbolom JOKER (Žolík) (plná obrazovka), " +
					"získa výhru rovnajúcu sa 500-násobku aktuálnej stávky na hru.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "BONUSOVÁ HRA FREE SPINS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"3 symboly HVIEZDA kdekoľvek na valcoch (SCATTER) spúšťajú bonusovú hru FREE SPINS. " +
					"Hráč obdrží 5 bonusových hier Free spins s roztiahnutým symbolom Hviezda (SCATTER) na celých valcoch 1, 3 a 5. " +
					"V priebehu bonusových otočení sú výhry úmerné stávke hry, v rámci ktorej boli bonusové otočenia spustené. " +
					"V priebehu bonusových otočení nie je možné získať ďalšie otočenia zdarma.",
				styles: textShort,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	en: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "BASIC INFORMATION:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"A five-reel game on 40 winning ways. " +
					"Winnings are valid from the left to right. " +
					"During one game, you can win on multiple winning ways, which means that the winnings are added up. " +
					"Only the highest win on the winning way is valid. " +
					"The theoretical return to player for this game is 95%.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SYMBOL JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "The JOKER symbol substitutes any symbol.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text: "Whenever the player gets a reel full of one of the symbols, the whole reel changes to the JOKER symbol in the next spin with the same bet.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "FREE SPINS BONUS GAME:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Three STAR symbols anywhere on the reels (SCATTER) trigger a FREE SPINS bonus game. " +
					"Player gets 5 free spins with the STAR (SCATTER) symbol on all the whole reels 1, 3, and 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	ro: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "Informații de bază:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Joc pe 5 cilindrii cu 40 de linii câștigătoare. " +
					"Câștigurile sunt valabile de la stânga la dreapta. " +
					"În timpul jocului, se poate câștiga pe mai multe linii câștigătoare, sumele fiind adunate. " +
					"Doar cel mai mare câștig de pe linia câștigătoare este valabil. " +
					"Randamentul teoretic pentru jucător în acest joc este de 95%.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SIMBOLUL JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Simbolul JOKER înlocuiește orice simbol.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text: " Oricând jucătorul primește un cilindru plin cu unul din simboluri, întreg cilindrul se schimbă în simbolul JOKER în următorul spin cu același bet.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "JOCUL BONUS FREE SPINS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					" 3 Simboluri STAR oriunde pe cilindrii (SCATTER) declanșează jocurile bonus FREE SPINS. " +
					"Jucătorul primește 5 FREE SPINS cu simbolul SCATTER întins pe intregi cilindrii 1,3 și 5.",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	hr: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "Osnovne informacije:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Igra s pet valjaka na 40 dobitnih linija. " +
					"Dobitci su mogući slijeva nadesno. " +
					"Tijekom jedne igre moguće je ostvariti dobitak na više dobitnih linija, što znači da se dobitci zbrajaju. " +
					"Vrijedi samo najviši dobitak na dobitnoj liniji.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SIMBOL DŽOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Simbol DŽOKER zamjenjuje bilo koji simbol.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text: "Kada god igrač dobije valjak pun istih simbola, cijeli se valjak mijenja u simbol DŽOKER u sljedećem okretanju s istom okladom.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "BONUS IGRA FREE SPINS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"3 simbola ZVIJEZDA bilo gdje na valjcima (SCATTER) aktiviraju bonus igru FREE SPINS. " +
					"Igrač dobiva 5 FREE SPINS sa simbolom SCATTER ispruženim na valjcima 1, 3 i 5.",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	es: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "Información básica:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Juego de 5 rodillos con 40 formas de ganar. " +
					"Las ganancias son válidas de izquierda a derecha. " +
					"En un juego, puedes ganar de varias formas, lo que significa que las ganancias se suman. " +
					"Solo la ganancia mayor de la forma de ganar es válida.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SÍMBOLO DE COMODÍN:",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: 'El símbolo de JOKER sustituye a cualquier símbolo."',
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Cuando el jugador consigue un rodillo lleno de uno de los símbolos, " +
					"todo el rodillo se convierte en el símbolo de JOKER en el siguiente giro con la misma apuesta.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "JUEGO DE BONIFICACIÓN DE GIROS GRATIS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Tres símbolos de ESTRELLA en cualquier parte de los rodillos (DISPERSIÓN) activan un juego de bonificación de GIROS GRATIS." +
					"Los jugadores obtienen 5 giros gratis con el símbolo de JOKER en los rodillos 1, 3 y 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "GIROS GRATIS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	"es-mx": {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "Información básica:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Juego de 5 rodillos con 40 formas de ganar. " +
					"Las ganancias son válidas de izquierda a derecha. " +
					"En un juego, puedes ganar de varias formas, lo que significa que las ganancias se suman. " +
					"Solo la ganancia mayor de la forma de ganar es válida.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SÍMBOLO DE COMODÍN:",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: 'El símbolo de JOKER sustituye a cualquier símbolo."',
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Cuando el jugador consigue un rodillo lleno de uno de los símbolos, " +
					"todo el rodillo se convierte en el símbolo de JOKER en el siguiente giro con la misma apuesta.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "JUEGO DE BONIFICACIÓN DE GIROS GRATIS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Tres símbolos de ESTRELLA en cualquier parte de los rodillos (DISPERSIÓN) activan un juego de bonificación de GIROS GRATIS." +
					"Los jugadores obtienen 5 giros gratis con el símbolo de JOKER en los rodillos 1, 3 y 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "GIROS GRATIS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	pl: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 70,
				text: "PODSTAWOWE INFORMACJE:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 105,
				text:
					"Gra 5-bębnowa z 40 wygrywającymi drogami. " +
					"Wygrane są zatwierdzane od lewej do prawej W trakcie gry można uzyskać wygrane na wielu wygrywających drogach, " +
					"co oznacza, że wygrane te są sumowane. " +
					"Brana jest pod uwagę tylko najwyższa wygrana na danej wygrywającej drodze",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SYMBOL JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Symbol JOKERA zastępuje dowolny symbol.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Za każdym razem, gdy gracz uzyska bęben pełen jednakowych symboli, " +
					"cały bęben zamienia się w symbol JOKERA podczas kolejnego spinu z tym samym zakładem.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "GRA BONUSOWA DARMOWE SPINY:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Trzy symbole GWIAZDKI w dowolnych miejscach na bębnach (SCATTER) aktywują grę bonusową DARMOWE SPINY, " +
					"Gracz zyskuje 5 darmowych spinów w przypadku wystąpienia symbolu JOKERA na całych bębnach 1, 3 i 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 30,
				x2: 1215,
				y: 350,
				fontSize: 16,
				text: "LINII",
			},
		},
	},
	fr: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "INFORMATIONS DE BASE:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Jeu de 5 rouleaux sur 40 lignes gagnantes. " +
					"Les gains sont valables de gauche à droite. " +
					"Pendant une partie, vous pouvez gagner sur plusieurs lignes gagnantes, " +
					"ce qui signifie que les gains s'additionnent. " +
					"Seul le gain le plus élevé sur la ligne gagnante est valable. " +
					"Le retour théorique au joueur pour ce jeu est de 95 %.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SYMBOLE JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Le symbole JOKER remplace n'importe quel symbole.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Chaque fois que le joueur obtient un rouleau rempli d'un des symboles, " +
					"le rouleau entier se transforme en symbole JOKER lors du prochain tour avec la męme mise.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "PARTIE BONUS FREE SPINS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Trois symboles ÉTOILE n'importe où sur les rouleaux (SCATTER) déclenchent une partie bonus Free Spins. " +
					"Le joueur reçoit 5 Free Spins avec le symbole ÉTOILE (SCATTER) sur tous les rouleaux entiers 1, 3 et 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 23,
				x2: 1208,
				y: 350,
				fontSize: 14,
				text: "LIGNES",
			},
		},
	},
	de: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "GRUNDLEGENDE INFORMATIONEN:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Ein Spiel mit fünf Walzen und 40 Gewinnmöglichkeiten. " +
					"Die Gewinnreihenfolge ist links nach rechts. " +
					"Während eines Spiels kannst du auf mehreren Gewinnlinien gewinnen. " +
					"Das bedeutet, dass deine Gewinne addiert werden. " +
					"Es gilt nur der höchste Gewinn auf der Gewinnlinie. " +
					"Die theoretische Spielerrendite für dieses Spiel beträgt 95,00 %.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "JOKER-SYMBOL (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Das JOKER-Symbol ersetzt jedes andere Symbol.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Wenn ein Spieler eine Walze desselben Symbols erhält, " +
					"zeigt die Walze beim nächsten Spiel mit demselben Einsatz das JOKER-Symbol.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "BONUSSPIEL MIT FREE SPINS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Erscheinen drei STERN-Symbole auf den Walzen (SCATTER), erhält der Spieler FREE SPINS. " +
					"Der Spieler erhält 5 FREE SPINS mit dem STAR-(Scatter) Symbol auf den Walzen 1, 3 und 5.",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 20,
				x2: 1205,
				y: 350,
				fontSize: 14,
				text: "GEWINN\nLINIEN",
			},
		},
	},
	pt: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "INFORMAÇŐES BÁSICAS:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Um jogo de cinco carretéis em 40 combinaçőes vencedoras. " +
					"Os ganhos săo válidos da esquerda para a direita. " +
					"Durante um jogo, pode ganhar com várias combinaçőes vencedoras, o que significa que os ganhos săo acumulados. " +
					"É válido apenas o ganho mais elevado na combinaçăo vencedora.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SÍMBOLO DE JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "O símbolo de JOKER substitui qualquer símbolo.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Sempre que o jogador obtém um carretel cheio com um dos símbolos, " +
					"o carretel muda por completo para o símbolo de JOKER na jogada seguinte com a mesma aposta.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "JOGO DE BÓNUS COM JOGADAS GRATUITAS:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Tręs símbolos de ESTRELA em qualquer local nos carretéis (SCATTER) acionam o jogo de bónus JOGADAS GRATUITAS. " +
					"O jogador recebe 5 jogadas gratuitas com o símbolo de JOKER apresentado nos carretéis 1, 3 e 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LINES",
			},
		},
	},
	nl: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "ALGEMENE INFORMATIE:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"Een spel met vijf rollen, met 40 manieren om te winnen. Winsten gelden van links naar rechts. " +
					"Tijdens één spel kun je op meerdere manieren winnen, wat betekent dat de winsten bij elkaar worden opgeteld. " +
					"Alleen de hoogste winst op de winlijn is geldig. " +
					"The theoretische uitbetaling aan speler voor dit spel is 95%.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SYMBOOL JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Het JOKER-symbool vervangt elk willekeurig symbool.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Steeds als de speler een rol vol met één van de symbolen krijgt, " +
					"verandert de hele rol in het JOKER-symbool bij de volgende ronde met dezelfde inzet.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "VRIJE SPELLEN-BONUSSPEL:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Drie STER-symbolen op een willekeurige plek op de rollen (SCATTER) activeren een VRIJE SPELLEN-bonusspel. " +
					"De speler krijgt 5 vrije spellen met het STER(SCATTER)-symbool op de hele rollen 1, 3 en 5",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 100,
				text: "VRIJE\nSPELLEN",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 15,
				text: "LIJNEN",
			},
		},
	},
	bg: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "ОСНОВНА ИНФОРМАЦИЯ:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"5 барабана и 40 печеливши линии. Печалбите са валидни от ляво надясно. " +
					"В една игра можете да спечелите на няколко печеливши линии, което означава, че печалбите се сумират. " +
					"Валидна е само най-голямата печалба на печелившата линия. " +
					"Теоретичната възвръщаемост на играча за тази игра е 95%.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "СИМВОЛ ДЖОКЕР (УАЙЛД):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Символът ДЖОКЕР замества всеки символ.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "УАЙЛД:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text: "Когато играчът получи барабан, пълен с един от символите, целият барабан се променя на ДЖОКЕР символа при следващото завъртане със същия залог.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "БОНУС ИГРА БЕЗПЛАТНИ ЗАВЪРТАНИЯ:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Три символа на ЗВЕЗДА където и да било по барабаните (СКАТЕР) задействат бонус игра с БЕЗПЛАТНИ ЗАВЪРТАНИЯ. " +
					"Играчът получава 5 БЕЗПЛАТНИ ЗАВЪРТАНИЯ със символ на ЗВЕЗДА (СКАТЕР), разгънат на барабани 1, 3 и 5.",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 100,
				text: "БЕЗПЛАТНИ\nЗАВЪРТАНИЯ",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 21,
				x2: 1206,
				y: 350,
				fontSize: 14,
				text: "ЛИНИИ",
			},
		},
	},
	it: {
		texts: {
			game: {
				text: "Super Joker 40",
			},
			basicInformation: {
				x: 120,
				y: 50,
				text: "INFORMAZIONI DI BASE:",
				styles: headerStyle,
			},
			basicInformationText: {
				x: 120,
				y: 85,
				text:
					"‘Slot game’ con 5 rulli e 40 linee di vincita. Le Vincite sono valide da sinistra a destra. " +
					"Durante una sessione di gioco, è possibile vincere su più linee di vincita e in tal caso le vincite si sommano. " +
					"Solo la vincita più alta sulla linea di vincita è valida. " +
					"Questo gioco prevede un rimborso teorico per il giocatore pari a 95,00 %.",
				styles: textStyle2,
			},
			wildSymbol: {
				x: 310,
				y: 225,
				text: "SIMBOLO JOKER (WILD):",
				styles: headerStyle,
			},
			wildSymbolText: {
				x: 310,
				y: 260,
				text: "Il simbolo JOKER sostituisce qualsiasi altro simbolo.",
				styles: textStyle,
			},
			wild: {
				x: 120,
				y: 360,
				text: "WILD:",
				styles: headerStyle,
			},
			wildText: {
				x: 120,
				y: 395,
				text:
					"Ogni qualvolta il giocatore ottiene un rullo pieno di uno dei simboli, " +
					"l’intero rullo cambierŕ nel simbolo JOKER nello spin successivo con la stessa scommessa.",
				styles: textStyle2,
			},
			bonusGame: {
				x: 120,
				y: 495,
				text: "GIOCO BONUS CON FREE SPIN:",
				styles: headerStyle,
			},
			bonusGameText: {
				x: 120,
				y: 530,
				text:
					"Tre simboli STELLA presenti ovunque sui rulli (SCATTER) attivano un gioco bonus con FREE SPIN. " +
					"Il giocatore riceve 5 Free spin con il simbolo STELLA (SCATTER) espanso sui rulli 1, 3 e 5.",
				styles: textStyle,
			},
			freespins: {
				x: 350,
				y: 120,
				text: "FREE SPINS",
				styles: freeSpinStyle,
			},
			lines: {
				x1: 25,
				x2: 1210,
				y: 350,
				fontSize: 16,
				text: "LINEE",
			},
		},
	},
};
